import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { of } from "rxjs";
import { ApiTownPlanningConstants } from "../../constants/api-constants/api-town-planning.constants";
import { catchError, map, tap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { AppControllerService } from "../../../app-controller.service";
let TownplanningService = class TownplanningService {
    http;
    appControllerService;
    applicationTypeLimitCache = new Map();
    unlimitedApplicationTypeLimit = -1;
    constructor(http, appControllerService) {
        this.http = http;
        this.appControllerService = appControllerService;
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiTownPlanningConstants.URL}/${applicationId}/${ApiTownPlanningConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getApplicationTypeLimitObservable(moduleId) {
        if (!this.isValidModuleId(moduleId)) {
            return of(this.getUnlimitedApplicationTypeLimit());
        }
        const cachedLimit = this.getCachedApplicationTypeLimit(moduleId);
        if (cachedLimit !== null) {
            return of(cachedLimit);
        }
        const params = {
            moduleId
        };
        return this.http
            .get(this.buildGetApplicationTypeLimitUrl(), { params })
            .pipe(map((response) => this.parseApplicationTypeLimitResponse(response)), tap((applicationTypeLimit) => this.setCachedApplicationTypeLimit(moduleId, applicationTypeLimit)), catchError(() => of(this.getUnlimitedApplicationTypeLimit())));
    }
    buildGetApplicationTypeLimitUrl() {
        return `${ApiTownPlanningConstants.URL}/${ApiTownPlanningConstants.FUNCTION_GET_APPLICATION_TYPE_LIMIT}`;
    }
    parseApplicationTypeLimitResponse(response) {
        if (typeof response === "number" && Number.isFinite(response)) {
            return response;
        }
        if (response !== null && typeof response === "object" && "value" in response) {
            const valueProperty = response.value;
            if (typeof valueProperty === "number" && Number.isFinite(valueProperty)) {
                return valueProperty;
            }
        }
        return this.getUnlimitedApplicationTypeLimit();
    }
    isValidModuleId(moduleId) {
        return Number.isFinite(moduleId) && moduleId > 0;
    }
    getCachedApplicationTypeLimit(moduleId) {
        if (!this.applicationTypeLimitCache.has(moduleId)) {
            return null;
        }
        return this.applicationTypeLimitCache.get(moduleId);
    }
    setCachedApplicationTypeLimit(moduleId, applicationTypeLimit) {
        this.applicationTypeLimitCache.set(moduleId, applicationTypeLimit);
    }
    getUnlimitedApplicationTypeLimit() {
        return this.unlimitedApplicationTypeLimit;
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
TownplanningService = __decorate([
    Injectable({
        providedIn: "root"
    })
], TownplanningService);
export { TownplanningService };
